"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanFileSize = exports.toSnakeCase = exports.unCapitalize = exports.capitalize = exports.toBoolean = exports.toId = exports.toNumberOrNull = exports.toNumber = exports.toStringOrNull = exports.toTime = exports.toDate = exports.toString = exports.isNumeric = exports.trimSlashes = exports.slugify = exports.isString = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const isString = (x) => typeof x === 'string';
exports.isString = isString;
const slugify = (str) => {
    return str
        .toLowerCase()
        .replace(/[^a-z0-9_-]+/g, '-')
        .replace(/^-|-$/, '');
};
exports.slugify = slugify;
const trimSlashes = (str) => {
    return str.replace(/^\/|\/$/g, '');
};
exports.trimSlashes = trimSlashes;
const isNumeric = (v) => !isNaN(Number(v));
exports.isNumeric = isNumeric;
const toString = (prop) => `${prop !== null && prop !== void 0 ? prop : ''}`;
exports.toString = toString;
const toDate = (prop) => (prop ? Date.parse(prop) : null);
exports.toDate = toDate;
const toTime = (prop) => (0, exports.toString)(prop);
exports.toTime = toTime;
const toStringOrNull = (prop) => (prop ? (0, exports.toString)(prop) : null);
exports.toStringOrNull = toStringOrNull;
const toNumber = (prop) => Number(prop);
exports.toNumber = toNumber;
const toNumberOrNull = (prop) => prop ? (isNaN(Number(prop)) ? null : Number(prop)) : null;
exports.toNumberOrNull = toNumberOrNull;
exports.toId = exports.toString;
const toBoolean = (prop) => !!prop;
exports.toBoolean = toBoolean;
// ------------------------------------------------------------------------------------------------
// ---- Case operations ----
/**
 * Make the first letter of a string uppercase
 */
const capitalize = (str) => (str.charAt(0).toUpperCase() + str.slice(1));
exports.capitalize = capitalize;
/**
 * Make the first letter of a string lowercase
 */
const unCapitalize = (str) => (str.charAt(0).toLowerCase() + str.slice(1));
exports.unCapitalize = unCapitalize;
const toSnakeCase = (str) => { var _a; return ((_a = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) !== null && _a !== void 0 ? _a : []).join('_').toLowerCase(); };
exports.toSnakeCase = toSnakeCase;
// ------------------------------------------------------------------------------------------------
/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
const humanFileSize = (bytes, si = true, dp = 1) => {
    bytes = (0, exports.toNumber)(bytes);
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
    return bytes.toFixed(dp) + ' ' + units[u];
};
exports.humanFileSize = humanFileSize;
